import APIClient from '@/shared/http/clients/api'
// import { config } from 'vue/types/umd'

const resourceName = 'REEmpreendimentoArquivo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetLogoByEmpreendimentoId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetLogoByEmpreendimentoId/${id}`, data, config)
const GetAllByEnterprise = (EmpreendimentoId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllByEnterpriseId/${EmpreendimentoId}`, data, config)
const GetAllByEnterpriseByTypeEnum = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllByEnterpriseByTypeEnum`, data, config)
const GetEnumZcorretor = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnumZcorretor`, data, config)
const GetEnumZincorporacao = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnumZincorporacao`, data, config)
const GetEnumOutros = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnumOutros`, data, config)
const GetEnum = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnum`, data, config)
const SendImgWithEmpreendimentoid = (id, type, data = [], config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/sendImgByEmpreendimento/${id}/${type}`, data, config)
const SendLiksYoutube = (empreendimentoid, type, data = [], config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SendLiksYoutube/${empreendimentoid}/${type}`, data, config)
const GetAllArquivoConstructionsByEmpreendimento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllArquivoConstructionsByEmpreendimento/${id}/`, data, config)
const SendImgWithEmpreendimentoidConstructions = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/sendImgByEmpreendimento/${id}/9`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const ChangePdfStatus = (empreendimentoArquivoId, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/ChangeStatusPdf/${empreendimentoArquivoId}`, data, config)
const GetFileBase64 = (empreendimentoArquivoId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetFileBase64/${empreendimentoArquivoId}`, data, config)
const GetFileBase64ListByEnuns = (empreendimentoArquivoId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetFileBase64ListByEnuns/${empreendimentoArquivoId}`, data, config)

const FileEnterpriseRepository = {
  GetEnumZcorretor,
  GetEnumZincorporacao,
  GetEnumOutros,
  GetAllByEnterprise,
  Delete,
  GetAllByEnterpriseByTypeEnum,
  GetEnum,
  SendImgWithEmpreendimentoid,
  GetAllArquivoConstructionsByEmpreendimento,
  SendImgWithEmpreendimentoidConstructions,
  GetLogoByEmpreendimentoId,
  ChangePdfStatus,
  SendLiksYoutube,
  GetFileBase64,
  GetFileBase64ListByEnuns
}

export default FileEnterpriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/fileenterprise.js